module.exports = "<div class=\"holder\">\n  <div>\n    <span class=\"access\"\n          [ngClass]=\"{'public': model.public, 'internal': !model.public}\"\n          (click)=\"model.public=!model.public\">\n    {{model.public?\"public\":\"internal\"}}\n    </span>\n    <span class=\"method\"\n          (click)=\"model.method=nextMethod()\">\n      {{model.method}}\n    </span>\n  </div>\n  <div>\n    <input class=\"path\" [(ngModel)]=\"model.path\" type=\"text\"/>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/editor/general/general.component.html
// module id = ./src/app/components/editor/general/general.component.html
// module chunks = main